import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SALETYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SaleType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SaleType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const SALETYPE_CONFIG = {
  entityName: 'SaleType',
  localizationKey: 'Controlling::Entity.SaleType',
  fields: SALETYPE_FIELDS,
  permission: 'ControllingLiquidations.SaleTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
